import { PieChart, Pie, ResponsiveContainer } from 'recharts';

import './WasteTypePercentageBlock.scss';

interface WasteTypePercentageProps {
  graphData: any[];
  tableData: any[];
};

const WasteTypePercentageBlock = (props: WasteTypePercentageProps) => {
  const displayedTableData = props.tableData.map((td, i) => {
    return [
      props.graphData[i].fill,
      td[0],
      td[1],
      td[2]
    ];
  });
  const totalWasteCount = displayedTableData.reduce((acc, curr) => acc + parseFloat(curr[2]), 0).toFixed(3);
  return (
    <div className='split-container' style={{ marginTop: 20 }}>
      <div className='graph'>
        <div className='total-waste-counter'>
          <h3>Total Weight</h3>
          <h3>{totalWasteCount + 't'}</h3>
        </div>
        <ResponsiveContainer width='100%' height={960} style={{ position: 'relative' }}>
          <PieChart>
            <Pie
              data={props.graphData}
              dataKey='value'
              nameKey='name'
              outerRadius='80%'
              innerRadius='40%'
              fill='#8884d8'
              isAnimationActive={false}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className='table'>
        <table>
          <tr>
            <th style={{ width: '3%', backgroundColor: 'transparent', border: 'transparent' }}></th>
            <th style={{ width: '63.7%' }}>Waste Type</th>
            <th style={{ width: '16.7%' }}>t</th>
            <th style={{ width: '16.7%' }}>%</th>
          </tr>
          {displayedTableData.filter(wt => !wt[1].startsWith('<')).map((wt, idx) =>
            <tr key={'wt-percentage-export-' + idx}>
              <td style={{ width: '3%', border: 'transparent' }}>
                <div className='color-circle' style={{ backgroundColor: wt[0] }}></div>
              </td>
              <td style={{ width: '63.7%' }}>{wt[1]}</td>
              <td style={{ width: '16.7%' }}>{wt[2]}</td>
              <td style={{ width: '16.7%' }}>{wt[3]}</td>
            </tr>
          )}
        </table>
      </div>
    </div>
  );
};

export default WasteTypePercentageBlock;